/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import {ADN_TARGETING_TYPES} from '../targeting-constants';
import {TargetingHelper} from '../targeting-helper';

import {TARGETING_IMPORTS} from '../targeting-imports';

@Component({
  imports: TARGETING_IMPORTS,
  selector: 'adn-targeting-named-location-summary',
  template: '<strong *ngIf="targets?.negated">NOT:&nbsp;</strong>{{locations}}'
})
export class NamedLocationSummaryComponent implements OnChanges {
  @Input() targets: any;

  locations = '';

  ngOnChanges(): void {
    this.locations = TargetingHelper.getSummary(this.targets || {}, ADN_TARGETING_TYPES.namedLocation) as string;
  }
}
